import App from './App';
import init from '../init';
import routes from './routes';

init(App, routes);
